import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

const Panel = ({ title, children, right, testid }) => (
  <div className="rounded-2xl bg-zinc-900 border border-zinc-800 p-6" data-testid={testid}>
    <div className="flex items-center justify-between mb-5">
      <span className="text-xs uppercase tracking-[0.2em] text-zinc-400 font-semibold">{title}</span>
      {right}
    </div>
    {children}
  </div>
);

const CTip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-lg bg-zinc-950 border border-zinc-700 px-3 py-2 text-xs font-mono">
      <div className="text-zinc-100 font-bold">Number {d.number}</div>
      <div className="text-zinc-400">Drawn {d.count}× ({d.pct}%)</div>
    </div>
  );
};

export const FrequencyChart = ({ hot, cold, color }) => {
  return (
    <Panel title="Frequency — Hot vs Cold" testid="frequency-chart">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <div className="text-[11px] font-semibold text-[#FF3B30] mb-2 uppercase tracking-wider">🔥 Hottest 10</div>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={hot} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
              <XAxis dataKey="number" tick={{ fill: "#71717a", fontSize: 11, fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill: "#52525b", fontSize: 10 }} axisLine={false} tickLine={false} />
              <Tooltip content={<CTip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
              <Bar dataKey="count" radius={[4, 4, 0, 0]}>
                {hot.map((entry, i) => <Cell key={entry.number} fill="#FF3B30" fillOpacity={1 - i * 0.055} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div>
          <div className="text-[11px] font-semibold text-[#00E5FF] mb-2 uppercase tracking-wider">❄ Coldest 10</div>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={cold} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
              <XAxis dataKey="number" tick={{ fill: "#71717a", fontSize: 11, fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill: "#52525b", fontSize: 10 }} axisLine={false} tickLine={false} />
              <Tooltip content={<CTip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
              <Bar dataKey="count" radius={[4, 4, 0, 0]}>
                {cold.map((entry, i) => <Cell key={entry.number} fill="#00E5FF" fillOpacity={0.5 + i * 0.05} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Panel>
  );
};

export const SpecialBallChart = ({ data, color, name }) => (
  <Panel title={`${name} Frequency`} testid="special-ball-chart">
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} margin={{ top: 4, right: 4, left: -22, bottom: 0 }}>
        <XAxis dataKey="number" tick={{ fill: "#52525b", fontSize: 9 }} axisLine={false} tickLine={false} interval={0} />
        <YAxis tick={{ fill: "#52525b", fontSize: 10 }} axisLine={false} tickLine={false} />
        <Tooltip content={<CTip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
        <Bar dataKey="count" radius={[3, 3, 0, 0]}>
          {data.map((d) => <Cell key={d.number} fill={color} fillOpacity={0.35 + d.heat * 0.65} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </Panel>
);

export { Panel };
